import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2048af5d = () => interopDefault(import('../../../pages/2022.vue' /* webpackChunkName: "pages/2022" */))
const _2056c6de = () => interopDefault(import('../../../pages/2023.vue' /* webpackChunkName: "pages/2023" */))
const _2064de5f = () => interopDefault(import('../../../pages/2024.vue' /* webpackChunkName: "pages/2024" */))
const _4bb13295 = () => interopDefault(import('../../../pages/media.vue' /* webpackChunkName: "pages/media" */))
const _7ef0e287 = () => interopDefault(import('../../../pages/posts/index.vue' /* webpackChunkName: "pages/posts/index" */))
const _0c875302 = () => interopDefault(import('../../../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _0f6c49f8 = () => interopDefault(import('../../../pages/sponsors.vue' /* webpackChunkName: "pages/sponsors" */))
const _c80a76fa = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7d3a413f = () => interopDefault(import('../../../pages/posts/_slug.vue' /* webpackChunkName: "pages/posts/_slug" */))
const _cb77b98a = () => interopDefault(import('../../../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/2022/",
    component: _2048af5d,
    pathToRegexpOptions: {"strict":true},
    name: "2022"
  }, {
    path: "/2023/",
    component: _2056c6de,
    pathToRegexpOptions: {"strict":true},
    name: "2023"
  }, {
    path: "/2024/",
    component: _2064de5f,
    pathToRegexpOptions: {"strict":true},
    name: "2024"
  }, {
    path: "/media/",
    component: _4bb13295,
    pathToRegexpOptions: {"strict":true},
    name: "media"
  }, {
    path: "/posts/",
    component: _7ef0e287,
    pathToRegexpOptions: {"strict":true},
    name: "posts"
  }, {
    path: "/register/",
    component: _0c875302,
    pathToRegexpOptions: {"strict":true},
    name: "register"
  }, {
    path: "/sponsors/",
    component: _0f6c49f8,
    pathToRegexpOptions: {"strict":true},
    name: "sponsors"
  }, {
    path: "/",
    component: _c80a76fa,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/posts/:slug/",
    component: _7d3a413f,
    pathToRegexpOptions: {"strict":true},
    name: "posts-slug"
  }, {
    path: "/:slug/",
    component: _cb77b98a,
    pathToRegexpOptions: {"strict":true},
    name: "slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
